import { render, staticRenderFns } from "./addClearRetreatPhoto.vue?vue&type=template&id=4b558516&scoped=true&"
import script from "./addClearRetreatPhoto.vue?vue&type=script&lang=js&"
export * from "./addClearRetreatPhoto.vue?vue&type=script&lang=js&"
import style0 from "./addClearRetreatPhoto.vue?vue&type=style&index=0&id=4b558516&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b558516",
  null
  
)

export default component.exports